(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management.pass', {
            url: '/{login}/pass',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.account.password'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-password.html',
                    controller: 'PasswordUpdateByLoginController',
                    controllerAs: 'vm',
                    //backdrop: 'static',
                    //size: 'lg',
                    size: 'md',
                    resolve: {
                        login: [ function() {
                            return $stateParams.login;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('password');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: 'user-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
